import React, { useState } from 'react';
import { Loader2, PackageCheck, AlertTriangle } from 'lucide-react';
import { tagThemeClass } from './tagTheme';

// Confirms marking pieces as physically received. Receipt is permanent.
export function TagReceiveConfirm({ pieces, onClose, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const n = pieces.length;
  const go = async () => { setBusy(true); try { await onConfirm(pieces); } finally { setBusy(false); } };
  return (
    <div className={`tag-scope ${tagThemeClass()} fixed inset-0 z-[200] flex items-center justify-center p-3`} data-testid="tagws-receive-confirm">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={busy ? undefined : onClose} />
      <div className="relative w-full max-w-md rounded-2xl border border-border bg-card p-5 shadow-2xl animate-in fade-in zoom-in-95 duration-150">
        <div className="flex items-center gap-2.5">
          <span className="grid h-10 w-10 place-items-center rounded-xl bg-emerald-600/15 text-emerald-700 dark:text-emerald-400"><PackageCheck size={20} /></span>
          <h2 className="text-lg font-bold text-foreground" data-testid="tagws-receive-confirm-title">Mark {n} {n === 1 ? 'item' : 'items'} as received?</h2>
        </div>
        <div className="mt-3 max-h-32 overflow-y-auto rounded-lg border border-border/70 bg-secondary/40 px-3 py-2 font-mono text-xs text-foreground" data-testid="tagws-receive-confirm-list">
          {pieces.map((p) => p.jewellery_no).join(', ')}
        </div>
        <p className="mt-3 flex items-start gap-1.5 text-xs font-medium text-amber-700 dark:text-amber-400" data-testid="tagws-receive-confirm-warning">
          <AlertTriangle size={14} className="mt-0.5 shrink-0" /> This cannot be undone. Once received, items cannot be marked as not received.
        </p>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} disabled={busy} className="h-9 rounded-xl border border-border px-4 text-sm font-semibold text-foreground hover:bg-secondary disabled:opacity-50" data-testid="tagws-receive-confirm-cancel">Cancel</button>
          <button type="button" onClick={go} disabled={busy} className="inline-flex h-9 items-center gap-1.5 rounded-xl bg-emerald-700 px-4 text-sm font-semibold text-white shadow-md shadow-emerald-700/25 transition-transform duration-150 hover:-translate-y-0.5 disabled:opacity-60" data-testid="tagws-receive-confirm-ok">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <PackageCheck size={14} />} Yes, mark received
          </button>
        </div>
      </div>
    </div>
  );
}
